import {
    Image,
    Tooltip,
    Box,
    useColorModeValue,
    Portal,
    Button,
    Text,
    Flex,
    Skeleton,
    CloseButton
} from '@chakra-ui/react';
import { DashboardLinksRow } from 'components/OtherBrowser';
import {
    tooltipAnimation,
    tooltipDownAnimation
} from 'components/sharedCode/components/customTheme';
import { AnimatePresence, motion } from 'framer-motion';
import Link from 'next/link';
import { useState } from 'react';

const TabsList = () => {
    const [hoverSide, setHoverItem] = useState(false);

    const hover = {
        on: () => {
            //calculateAndSetPosition();
            setHoverItem(true);
        },
        off: () => {
            //setActiveInfoPopIndex(index);
            setHoverItem(false);
        }
    };

    const emptyBg = useColorModeValue('gray.300', '#35393c');

    const emptyStyle = {
        height: '32px',
        width: '32px',
        rounded: '8px',
        my: '6px',
        cursor: 'pointer',
        bg: emptyBg,
        display: 'flex',
        alignItems: 'center'
    };

    return (
        <Flex
            flexDir={'column'}
            w={['0px', '0px', '72px']}
            margin="0"
            zIndex={12}
            pos={'relative'}
            p="16px 18px"
            display={['none', 'none', 'flex']}
        >
            <Link href="/">
                <Tooltip
                    label="← Back"
                    rounded="6px"
                    motionProps={tooltipDownAnimation}
                    placement="top"
                    px="6px"
                    py="3px"
                >
                    <Image
                        src={'/tabExtend_logo_square.png'}
                        h="32px"
                        w="32px"
                        mt="6px"
                        mb="16px"
                        cursor={'pointer'}
                        _hover={{ filter: 'brightness(1.1225)' }}
                    />
                </Tooltip>
            </Link>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    cursor: 'pointer'
                }}
                onMouseEnter={hover.on}
                onMouseOver={hover.on}
                onMouseLeave={hover.off}
                onClick={() => setHoverItem(true)}
            >
                <Box {...emptyStyle} opacity={0.675}>
                    {hoverSide && (
                        <Skeleton
                            height="18px"
                            w="18px"
                            rounded="6px"
                            m="auto"
                            startColor={emptyBg}
                        />
                    )}
                </Box>
                <Box {...emptyStyle} opacity={0.525}>
                    {hoverSide && (
                        <Skeleton
                            height="18px"
                            w="18px"
                            rounded="6px"
                            m="auto"
                            startColor={emptyBg}
                        />
                    )}
                </Box>
                <Box {...emptyStyle} opacity={0.225}>
                    {hoverSide && (
                        <Skeleton
                            height="18px"
                            w="18px"
                            rounded="6px"
                            m="auto"
                            startColor={emptyBg}
                        />
                    )}
                </Box>
            </div>
            {hoverSide && (
                <Portal>
                    <motion.div
                        initial={{
                            //scale: 0.9625
                            //x: -12
                            x: -8
                        }}
                        animate={{
                            //scale: 1
                            //x: 0
                            x: 0,
                            opacity: 1
                        }}
                        /* exit={{
                                scale: 0.975,
                                opacity: 0,
                                transition: { opacity: { duration: 0.1 } }
                            }} */
                        style={{
                            originX: 0,
                            originY: '50%',
                            background: 'var(--chakra-colors-modalBg)',
                            borderRadius: '14px',
                            position: 'fixed', // Use fixed to ensure it's positioned relative to the viewport
                            top: 62,
                            left: 78,
                            boxShadow:
                                'var(--chakra-colors-popoverShadowLight)',
                            zIndex: 1000 // Ensure it's above other elements
                        }}
                        onMouseEnter={hover.on}
                        onMouseOver={hover.on}
                        onMouseLeave={hover.off}
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        <Box
                            pos="absolute"
                            bg="transparent"
                            top="0px"
                            opacity={0.5}
                            left={'-32px'}
                            height="calc(100% + 14px)"
                            w="calc(100% + 32px)"
                            //make clickthrough
                            zIndex={'-1'}
                        />
                        <div
                            style={{
                                padding: '20px',
                                zIndex: 14,
                                maxWidth: '364px',
                                minWidth: '308px'
                            }}
                        >
                            <CloseButton
                                m="8px 4px"
                                opacity="0.5"
                                rounded="8px"
                                cursor="pointer"
                                bg="transparent"
                                color="gray.500"
                                size={'sm'}
                                pos="absolute"
                                right="6px"
                                top="2px"
                                onClick={() => setHoverItem(false)}
                            />
                            <Text fontSize={'16px'} fontWeight={'700'}>
                                Active tabs list
                            </Text>
                            <Text
                                mt="4px"
                                fontSize={'12px'}
                                fontWeight={'500'}
                                color="secondaryText"
                            >
                                Add the browser extension with one click to
                                access your active tabs(drag + drop to quickly
                                close and save, etc).
                            </Text>
                            <MiniBrowserSideBar />
                            {/* <Text
                                mt="4px"
                                fontSize={'12px'}
                                fontWeight={'500'}
                                color="secondaryText"
                            >
                                Read more about all the features of the
                                extension here.
                            </Text> */}
                            {/* <Button>hey</Button> */}
                            <Text
                                fontSize="11px"
                                fontWeight={'500'}
                                color="secondaryText"
                                mb="4px"
                            >
                                Choose your browser:
                            </Text>
                            <DashboardLinksRow type={'web'} />
                            <Text
                                fontSize="11px"
                                fontWeight={'500'}
                                color="secondaryText"
                                mb="4px"
                                mt="8px"
                            >
                                And/or use the mobile version
                            </Text>
                            <DashboardLinksRow type={'mobile'} />
                        </div>
                    </motion.div>
                </Portal>
            )}
        </Flex>
    );
};

export default TabsList;

const MiniBrowserSideBar = () => {
    const bg = useColorModeValue('gray.100', 'var(--chakra-colors-bg0)');
    const tab = useColorModeValue('gray.100', '#484C4D');
    const other = useColorModeValue('#FFF', '#484C4D');
    const borderBottom = useColorModeValue(
        '1px solid #e4eaf0',
        '1px solid #394146'
    );

    return (
        <Flex
            my="8px"
            p="4px"
            rounded="12px"
            bg={bg}
            w="100%"
            h="114px"
            border={borderBottom}
        >
            <Flex
                border="2px solid #5ba6ff"
                rounded="10px"
                p="12px 6px 8px"
                bg="var(--chakra-colors-modalBg)"
                w="73px"
                flexDir={'column'}
            >
                <Flex>
                    <Box w="10px" h="10px" rounded="3px" bg={tab} mr="4px" />
                    <Box h="10px" flex="1" rounded="3px" bg={tab} />
                </Flex>
                <Flex mt="4px">
                    <Box w="10px" h="10px" rounded="3px" bg={tab} mr="4px" />
                    <Box h="10px" flex="1" rounded="3px" bg={tab} />
                </Flex>
                <Flex mt="4px">
                    <Box w="10px" h="10px" rounded="3px" bg={tab} mr="4px" />
                    <Box h="10px" flex="1" rounded="3px" bg={tab} />
                </Flex>
            </Flex>
            <Box mt="4px" ml="8px" opacity={0.6}>
                <Flex w="84px">
                    <Box w="12px" h="12px" rounded="4px" bg={other} mr="4px" />
                    <Box h="12px" flex="1" rounded="4px" bg={other} />
                </Flex>
                <Flex flex="1" mt="8px" gap="8px">
                    <Box h="80px" w="52px" bg={other} rounded="10px" />
                    <Box h="80px" w="52px" bg={other} rounded="10px" />
                    <Box h="80px" w="52px" bg={other} rounded="10px" />
                    <Box h="80px" w="52px" bg={other} rounded="10px" />
                </Flex>
            </Box>
        </Flex>
    );
};
